var checkBox = document.getElementById("RegisterForm-AcceptsMarketing");
var newsletter_check = document.getElementById("newsletterTag");
if(checkBox.value == null) {
  checkBox.addEventListener('change', function () {
    if (checkBox.checked) {
      newsletter_check.disabled = false;
    } else {
      newsletter_check.disabled = true;
    }
  });
}